import './navExpense.css';

export default function NavExpense() {
    return(
        <div>
            <svg width="25.611" height="19.918" viewBox="0 0 25.611 19.918">
                <path id="Icon_fa-solid-money-bill-wave" data-name="Icon fa-solid-money-bill-wave" d="M0,5.83V19.6a1.927,1.927,0,0,0,1.2,1.836c3.868,1.445,7.737.458,11.605-.529,3.548-.9,7.1-1.81,10.64-.84a1.679,1.679,0,0,0,2.165-1.485V4.816a1.927,1.927,0,0,0-1.2-1.836c-3.868-1.445-7.737-.458-11.605.529-3.548.9-7.1,1.805-10.64.836A1.677,1.677,0,0,0,0,5.83ZM12.806,16.479c-1.965,0-3.557-1.912-3.557-4.269s1.592-4.269,3.557-4.269,3.557,1.912,3.557,4.269S14.771,16.479,12.806,16.479Zm-9.96,0a2.848,2.848,0,0,1,2.846,2.846H2.846ZM5.691,7.23a2.848,2.848,0,0,1-2.846,2.846V7.23Zm17.074,7.114V17.19H19.92A2.848,2.848,0,0,1,22.765,14.344ZM19.92,5.1h2.846V7.942A2.848,2.848,0,0,1,19.92,5.1Z" transform="translate(0 -2.251)" fill="#88cdf6"/>
            </svg>
        </div>
    )
}